import { OrganizationUsersResponse } from '../api/organization';
import { WorkspaceAccessResponse } from '../api/workspace';
import { User } from '../types/User';
import { getUserProfilePictureUrl } from './userHelper';
import { publicEmailDomains, temporaryEmailDomains } from './emailDomains';

export const getProfilePictureUrl = (user: Partial<User>) => {
  if (user.profilePicturePath) {
    return getUserProfilePictureUrl(user.profilePicturePath);
  }
  return '';
};

export const isValidEmail = (value: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(value);
};

const publicEmailDomainSet = new Set(publicEmailDomains);
const temporaryEmailDomainSet = new Set(temporaryEmailDomains);

function normalizedDomain(email: string) {
  return (email.split('@').pop() || '').trim().toLowerCase();
}

export function isCompanyEmail(email: string) {
  return !publicEmailDomainSet.has(normalizedDomain(email)) && !isTemporaryEmail(email);
}

export function extractDomain(email: string) {
  return email.split('@')[1];
}

export function capitalizeFirstLetter(string: string): string {
  if (!string) return string; // Handle empty or null strings
  return string.charAt(0).toUpperCase() + string.slice(1);
}

// Also matches subdomains, since most disposable services hand out addresses on arbitrary ones.
export function isTemporaryEmail(email: string): boolean {
  const labels = normalizedDomain(email).split('.');
  return labels.slice(0, -1).some((_, i) => temporaryEmailDomainSet.has(labels.slice(i).join('.')));
}
